"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationShellWrapper = void 0;
var ApplicationShellWrapper = (function () {
    function ApplicationShellWrapper() {
        this.fnQueue = [];
        this.interval = 0;
        this.pollingTimeout = 30000;
    }
    ApplicationShellWrapper.getInstance = function () {
        if (!ApplicationShellWrapper.instance)
            ApplicationShellWrapper.instance = new ApplicationShellWrapper();
        return ApplicationShellWrapper.instance;
    };
    ApplicationShellWrapper.prototype.subscribeTo = function (topic, action, signature) {
        this.addQueue({ subscribeTo: [topic, action, signature] });
        if (window.shell)
            this.processQueue();
        else
            this.startPolling();
    };
    ApplicationShellWrapper.prototype.once = function (topic, action) {
        this.addQueue({ once: [topic, action] });
        if (window.shell)
            this.processQueue();
        else
            this.startPolling();
    };
    ApplicationShellWrapper.prototype.unsubscribeFrom = function (topic, signature) {
        this.addQueue({ unsubscribeFrom: [topic, signature] });
        if (window.shell)
            this.processQueue();
        else
            this.startPolling();
    };
    ApplicationShellWrapper.prototype.publishTo = function (topic, data) {
        this.addQueue({ publishTo: [topic, data] });
        if (window.shell)
            this.processQueue();
        else
            this.startPolling();
    };
    ApplicationShellWrapper.prototype.enableLogs = function () {
        this.addQueue({ enableLogs: undefined });
        if (window.shell)
            this.processQueue();
        else
            this.startPolling();
    };
    ApplicationShellWrapper.prototype.disableLogs = function () {
        this.addQueue({ disableLogs: undefined });
        if (window.shell)
            this.processQueue();
        else
            this.startPolling();
    };
    ApplicationShellWrapper.prototype.addQueue = function (fn) {
        this.fnQueue.push(fn);
    };
    ApplicationShellWrapper.prototype.processQueue = function () {
        var _this = this;
        if (this.interval !== 0)
            this.stopPolling();
        this.fnQueue.map(function (fn, idx) {
            var _a;
            var fnName = Object.keys(fn)[0];
            var fnParams = fn[fnName];
            (_a = window.shell)[fnName].apply(_a, fnParams);
            delete _this.fnQueue[idx];
        });
        this.fnQueue = this.fnQueue.filter(Boolean);
    };
    ApplicationShellWrapper.prototype.clearQueue = function () {
        this.fnQueue.length = 0;
    };
    ApplicationShellWrapper.prototype.startPolling = function () {
        var _this = this;
        if (this.interval !== 0)
            return;
        var pollingInterval = 500;
        var maxPolls = this.pollingTimeout / pollingInterval;
        var count = 0;
        this.interval = window.setInterval(function () {
            count++;
            if (count === maxPolls) {
                console.warn('Maximum waiting time for Application Shell exceeded - giving up.');
                _this.stopPolling();
                _this.clearQueue();
            }
            if (!!window.shell) {
                _this.stopPolling();
                _this.processQueue();
            }
        }, pollingInterval);
    };
    ApplicationShellWrapper.prototype.stopPolling = function () {
        window.clearInterval(this.interval);
    };
    return ApplicationShellWrapper;
}());
exports.ApplicationShellWrapper = ApplicationShellWrapper;
